import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { IFramePool } from '@tencent/halo-iframe-pool';
/* eslint-disable no-bitwise */
// TODO: 请不要复制这份代码, 后续要再封装 JsBridge 的时候, 把这份代码提取出来

/** 无 App 场景 */

var SCENE_NONE = 0;
/** 应用宝 */

var SCENE_DOWNLOADER = 1;
var SCENE_DOWNLOADER_DETAIL = 2 | SCENE_DOWNLOADER;
var SCENE_DOWNLOADER_EXTERNAL = 4 | SCENE_DOWNLOADER;
var SCENE_DOWNLOADER_SDK = 8 | SCENE_DOWNLOADER;
/** 手 Q */

var SCENE_MOBILEQ = 0x10;
/** 微信 */

var SCENE_WECHAT = 0x20;
/** YunOS */

var SCENE_YUNOS = 0x30;
/** QQ 音乐 */

var SCENE_QQMUSIC = 0x40;
/* 手机助手 */

var SCENE_SZUSE = 0x50;
/** 微视 */

var SCENE_WEISHI = 0x60;
/** 腾讯视频 */

var SCENE_VIDEO = 0x100;
/** 手管系 */

var SCENE_WESECURE_SERIES = 0x2000;
/** 手管 */

var SCENE_WESECURE = 0x2200;
/** Wifi 管家 */

var SCENE_WIFIMANAGER = 0x2300;
/** Wifi 管家 (支持下载接口) */

var SCENE_WIFIMANAGER_SUPPORT_DOWNLOAD = 0x2400;
/** 同步助手 */

var SCENE_QQPIM = 0x2500;
/** 同步助手 (支持下载接口) */

var SCENE_QQPIM_SUPPORT_DOWNLOAD = 0x2600;
/** 同步助手 (增强版，增加暂停及进度等接口) */

var SCENE_QQPIM_SUPPORT_DOWNLOAD_V2 = 0x2700;
/**
 * 用于调用 jsbridge:// 伪协议的 iframe 池子
 * @private
 */

var pool = new IFramePool();
/**
 * 客户端回调函数的前缀
 * @private
 */

var CALLBACK_PREFIX = "__MQQ_JSBRIDGE_CALLBACK__";
/**
 * 客户端回调函数的自增序号
 * @private
 */

var autoIncrement = 1;
/** JsBridge 错误 */

var JsBridgeError = /*@__PURE__*/function (Error) {
  function JsBridgeError(response) {
    var this$1 = this;
    Error.call(this, response.msg);
    Object.keys(response).forEach(function (key) {
      // @ts-ignore
      this$1[key] = response[key];
    });
    this.response = response;
  }

  if (Error) JsBridgeError.__proto__ = Error;
  JsBridgeError.prototype = Object.create(Error && Error.prototype);
  JsBridgeError.prototype.constructor = JsBridgeError;
  return JsBridgeError;
}(Error);
/**
 * 拼接 jsbridge:// 伪协议 url
 * @private
 */


function getSchemeUrl(name, params) {
  var prefix = "jsbridge://" + name.split(".").map(encodeURIComponent).join("/");

  if (params) {
    return prefix + "?p=" + encodeURIComponent(JSON.stringify(params));
  }

  return prefix;
}
/**
 * 将一个函数注册为客户端回调函数
 * @private
 */


function assignCallback(callback) {
  var id = autoIncrement++;
  window["" + CALLBACK_PREFIX + id] = callback;
  return id;
}
/**
 * 将一个客户端回调函数从全局变量中删除
 * @private
 */


function revokeCallback(id) {
  return delete window["" + CALLBACK_PREFIX + id];
}
/**
 * 转换响应对象格式
 * @private
 * @description
 * 如果在没有引入 mqq 的情况下, 得到的对象有可能不符合 JsBridgeResponse 格式,
 * 所以需要再做一次转换来保证响应的格式. 此逻辑由 mqq 改写而来.
 */


function transformResponse(response) {
  var code = response.code;
  var codeKeysToSearch = ["retCode", "retcode", "resultCode", "ret", "code", "r"];

  for (var i = 0, n = codeKeysToSearch.length; typeof code !== "number" && i < n; i++) {
    code = response[codeKeysToSearch[i]];
  }

  return {
    code: code,
    msg: response.msg || "",
    data: response.data || response
  };
}

function call(name, params, isVoid, callback) {
  if (params === void 0) params = {};

  if (callback) {
    call(name, params).then(callback, callback);
    return;
  }

  return pool.run(function (iframe) {
    return new Promise(function (resolve, reject) {
      if (isVoid) {
        // 对于没有响应内容的 JsBridge 接口, 直接 resolve
        iframe.src = getSchemeUrl(name, params);
        return resolve();
      } // 注册客户端回调函数


      var callbackId = assignCallback(function (rawResponse) {
        var response = transformResponse(rawResponse); // 根据返回的 code 判断应该 resolve 还是 reject

        if (response.code === 0) {
          resolve(response);
        } else {
          reject(new JsBridgeError(response));
        }

        revokeCallback(callbackId);
      }); // 微视的客户端回调函数需要由 params 对象中的 callback 属性指定

      params.callback = "" + CALLBACK_PREFIX + callbackId; // 通过 iframe 发送请求

      iframe.src = getSchemeUrl(name, params) + "#" + callbackId;
    });
  });
}
/**
 * 记录每次分享的 Promise 的 resolve 和 reject
 * @private
 */


var defers = {};
/**
 * 分享回调函数的前缀
 * @private
 */

var SHARE_CALLBACK_PREFIX = "__MQQ_JSBRIDGE_SHARE_CALLBACK__";
/**
 * 获取分享回调
 * @private
 */

function getShareCallback(platformType) {
  var callbackName = "" + SHARE_CALLBACK_PREFIX + platformType; // 如果分享回调在全局作用域中不存在, 就新建一个

  if (!window[callbackName]) {
    window[callbackName] = function (rawResponse) {
      var response = transformResponse(rawResponse); // 从 defers 中找出对应 Promise 的 resolve 和 reject

      if (!defers[platformType]) {
        return;
      }

      var ref = defers[platformType];
      var resolve = ref[0];
      var reject = ref[1];
      defers[platformType] = undefined;

      if (response.code === 0) {
        resolve(response);
      } else {
        reject(new JsBridgeError(response));
      }
    };
  }

  return callbackName;
}

function share(options, callback) {
  if (callback) {
    share(options).then(callback, callback);
    return;
  }

  return pool.run(function (iframe) {
    return new Promise(function (resolve, reject) {
      // 在 defers 中记录本次分享的 Promise 的 resolve 和 reject
      // 以便在回调中对 Promise 进行操作
      defers[options.platformType] = [resolve, reject]; // 发送分享请求

      options.callback = getShareCallback(options.platformType);
      iframe.src = "" + getSchemeUrl("share.shareMessage", options);
    });
  });
}

(function (share) {
  /** 分享目标平台 */
  var PlatformType;

  (function (PlatformType) {
    /** QQ 好友 */
    PlatformType[PlatformType["QQ"] = 0] = "QQ";
    /** QQ 空间 */

    PlatformType[PlatformType["QZONE"] = 1] = "QZONE";
    /** 微信好友 */

    PlatformType[PlatformType["WECHAT"] = 2] = "WECHAT";
    /** 微信朋友圈 */

    PlatformType[PlatformType["WECHAT_MOMENTS"] = 3] = "WECHAT_MOMENTS";
    /** 微博 */

    PlatformType[PlatformType["WEIBO"] = 4] = "WEIBO";
  })(PlatformType = share.PlatformType || (share.PlatformType = {}));

  var ErrorCode;

  (function (ErrorCode) {
    /** 用户取消分享 */
    ErrorCode[ErrorCode["CANCELLED"] = -1] = "CANCELLED";
    /** 应用未安装 */

    ErrorCode[ErrorCode["NOT_INSTALLED"] = -2] = "NOT_INSTALLED";
    /** 分享参数错误 */

    ErrorCode[ErrorCode["INVALID"] = -3] = "INVALID";
  })(ErrorCode = share.ErrorCode || (share.ErrorCode = {}));
})(share || (share = {}));

function setShareInfo(options, callback) {
  if (callback) {
    setShareInfo(options).then(callback, callback);
    return;
  }

  return call("data.setShareInfo", options,
  /* isVoid */
  false).catch(function (err) {
    if (err.code === 1) {
      return Promise.resolve(err.response);
    }

    return Promise.reject(err);
  });
}

function getDeviceInfo(callback) {
  return call("device.getDeviceInfo",
  /* params */
  undefined,
  /* isVoid */
  false, callback);
}

function getNetworkInfo(callback) {
  return call("device.getNetworkInfo",
  /* params */
  undefined,
  /* isVoid */
  false, callback);
}

(function (getNetworkInfo) {
  var NetworkType;

  (function (NetworkType) {
    /** 无网络 */
    NetworkType[NetworkType["NONE"] = 0] = "NONE";
    /** WiFi */

    NetworkType[NetworkType["WIFI"] = 1] = "WIFI";
    /** 2G 移动网络 */

    NetworkType[NetworkType["MOBILE_2G"] = 2] = "MOBILE_2G";
    /** 3G 移动网络 */

    NetworkType[NetworkType["MOBILE_3G"] = 3] = "MOBILE_3G";
    /** 4G 移动网络 */

    NetworkType[NetworkType["MOBILE_4G"] = 4] = "MOBILE_4G";
  })(NetworkType = getNetworkInfo.NetworkType || (getNetworkInfo.NetworkType = {}));
})(getNetworkInfo || (getNetworkInfo = {}));

function getPerformance(callback) {
  return call("data.getPerformance",
  /* params */
  undefined,
  /* isVoid */
  false, callback);
}

function login(options, callback) {
  if (options === void 0) options = {
    doLogin: true
  };

  if (typeof options === "function") {
    return login(undefined, options);
  }

  return call("weishi.login", options,
  /* isVoid */
  false, callback);
}

(function (login) {
  var AuthType;

  (function (AuthType) {
    AuthType[AuthType["QQ"] = 1] = "QQ";
    AuthType[AuthType["WECHAT"] = 3] = "WECHAT";
  })(AuthType = login.AuthType || (login.AuthType = {}));

  var ErrorCode;

  (function (ErrorCode) {
    /** 用户取消登录 */
    ErrorCode[ErrorCode["CANCELLED"] = -1] = "CANCELLED";
    /** 用户当前未登录 */

    ErrorCode[ErrorCode["NOT_LOGGED_IN"] = -2] = "NOT_LOGGED_IN";
  })(ErrorCode = login.ErrorCode || (login.ErrorCode = {}));
})(login || (login = {}));

function showShareMenu(callback) {
  call("ui.showShareMenu",
  /* params */
  undefined,
  /* isVoid */
  true, callback);
}

function setTitle(title, callback) {
  return call("weishi.setTitle", {
    title: title
  },
  /* isVoid */
  true, callback);
}

function updateProductSharePrivilege(options, callback) {
  return call("weishi.updateProductSharePrivilege", options,
  /* isVoid */
  true, callback);
}

function toast(options, callback) {
  if (typeof options.iconMode === "undefined") {
    options.iconMode = 2;
  }

  return call("ui.showTips", options,
  /* isVoid */
  true, callback);
}

(function (toast) {
  var IconMode;

  (function (IconMode) {
    /** 感叹号图标 */
    IconMode[IconMode["EXCLAME"] = 2] = "EXCLAME";
  })(IconMode = toast.IconMode || (toast.IconMode = {}));
})(toast || (toast = {}));

function closeWebViews(callback) {
  return call("ui.closeWebViews", undefined,
  /* isVoid */
  true, callback);
}

function openMiniProgram(options, callback) {
  return call("weishi.openMiniProgram",
  /* params */
  options,
  /* isVoid */
  false, callback);
}

(function (openMiniProgram) {
  var VersionType;

  (function (VersionType) {
    /** 正式版 */
    VersionType[VersionType["REALEASE"] = 0] = "REALEASE";
    /** 开发版 */

    VersionType[VersionType["DEV"] = 1] = "DEV";
    /** 体验版 */

    VersionType[VersionType["EXP"] = 2] = "EXP";
  })(VersionType = openMiniProgram.VersionType || (openMiniProgram.VersionType = {}));
})(openMiniProgram || (openMiniProgram = {}));

function getAMSMiniProgramReqParam(callback) {
  return call("weishi.getAMSMiniProgramReqParam",
  /* params */
  undefined,
  /* isVoid */
  false, callback);
}
/** 当前场景值 */


var SCENE = /WEISHI/.test(navigator.userAgent) ? SCENE_WEISHI : SCENE_NONE;
export { JsBridgeError, SCENE, SCENE_DOWNLOADER, SCENE_DOWNLOADER_DETAIL, SCENE_DOWNLOADER_EXTERNAL, SCENE_DOWNLOADER_SDK, SCENE_MOBILEQ, SCENE_NONE, SCENE_QQMUSIC, SCENE_QQPIM, SCENE_QQPIM_SUPPORT_DOWNLOAD, SCENE_QQPIM_SUPPORT_DOWNLOAD_V2, SCENE_SZUSE, SCENE_VIDEO, SCENE_WECHAT, SCENE_WEISHI, SCENE_WESECURE, SCENE_WESECURE_SERIES, SCENE_WIFIMANAGER, SCENE_WIFIMANAGER_SUPPORT_DOWNLOAD, SCENE_YUNOS, call, closeWebViews, getAMSMiniProgramReqParam, getDeviceInfo, getNetworkInfo, getPerformance, login, openMiniProgram, setShareInfo, setTitle, share, showShareMenu, toast, updateProductSharePrivilege };